import moment from "moment";
import React from "react";
import { useEffect, useState } from "react";
import { currentBetsAPI } from "../../service/AuthService";
import Loader from "../casino/components/Loader";


export default function BetHistory() {
  const [sport, setSport] = React.useState("cricket");
  const [isCasino, setIsCasino] = React.useState(false);
  const [pageNumber, setPageNumber] = React.useState(1);
    const [noOfPages, setNoOfPages] = React.useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [page, setPage] = React.useState(1);
  
  const [pageSize, setPageSize] = React.useState(1000);
  const [data, setData] = React.useState([]);
  const [betType, setBetType] = React.useState("cricket");
  const [search, setSearch] = React.useState("");
  const [betStatus, setBetStatus] = React.useState("MATCHED");
  const [totalElements, setTotalElements] = React.useState(0);
  const [totalPages, setTotalPages] = React.useState(0);
  // const [size, setSize] = React.useState(25);
  const [size, setSize] = React.useState(25);
  const [totalBets_, setTotalBets] = React.useState(0);
  const [totalAmount_, setTotalAmount] = React.useState(0);
  const [startDate, setStartDate] = React.useState(
    moment()
      .subtract(7, "days")
      .format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = React.useState(moment().format("YYYY-MM-DD"));

  const getCurrentBets = async () => {
    setIsLoading(true);
    const {
      response: {
        totalAmount,
        totalBets,
        unsettledBets: { content, totalElements, totalPages, size },
      },
    } = await currentBetsAPI({
      betStatus,
      betType,
      pageSize,
      pageNumber,
      search,
      sports: sport !== "Casino",
      fromDate: startDate,
      toDate: endDate,
    });

    let data_ = content.map((item) => ({
      ...item,
      rate: item.back_run ? item.back_run : item.lay_run,
      type: item.back_run ? "BACK" : "LAY",
    }));
    console.log("content", content);
    setIsLoading(false);
    setData(
      data_?.filter(
        (item) => item.event_type?.toLowerCase() === betType?.toLowerCase()
      )
    );
    setTotalElements(totalElements);
    setTotalPages(totalPages);
    setSize(size);
    setTotalBets(totalBets);
    setTotalAmount(totalAmount);
  };
  useEffect(() => {
    getCurrentBets();
  }, [pageNumber, pageSize, betType, search, betStatus, isCasino]);
  const isMobile = window.innerWidth < 786;

  const handlePageChange = (newPage) => {
    setPageNumber(newPage);
  };
  return (
    <div
      style={{
        width: isMobile ? "100%" : "82%",
      }}
      className={` report-main-content m-t-5`}
    >
      <div className="card">
        <div className="card-header">
            {/**/} {isLoading && <Loader />}
          <h4 className="mb-0">Bet History</h4>
        </div>
        <div className="card-body container-fluid container-fluid-5">
          <div className="row row5 mt-2">
            <div className={isMobile ? "col-12" : "col-2"}>
              <div className="form-group mb-0">
                <select
                  onChange={(e) => {
                    setSport(e.target.value);
                    setBetType(e.target.value);
                    // if (e.target.value === "Casino") {
                    //   setIsCasino(true);
                    // } else {
                    //   setIsCasino(false);
                    // }
                  }}
                  name="reportType"
                  className="custom-select"
                  value={sport}
                >
                  <option value="" disabled="disabled">
                    Sport Type
                  </option>
                  <option value={"football"}>Football</option>
                  <option value={"tennis"}>Tennis</option>
                  <option value={"cricket"}>Cricket</option>
                </select>
              </div>
            </div>
            <div className={isMobile ? "col-12 mt-2" : "col-2"}>
              <div className="form-group mb-0">
                <select
                  onChange={(e) => setBetStatus(e.target.value)}
                  name="reportType"
                  className="custom-select"
                  value={betStatus}
                >
                  <option value="" disabled="disabled">
                    Bet Status
                  </option>
                  <option value={"MATCHED"}>Matched</option>
                  {/* <option value={"DELETED"}>Deleted</option> */}
                </select>
              </div>
            </div>
            <div className={isMobile ? "col-12 mt-2" : "col-2"}>
              <div className="form-group mb-0">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
            </div>
            <div className={isMobile ? "col-12 mt-2" : "col-2"}>
              <div className="form-group mb-0">
                <input
                  type="date"
                  className="form-control form-control-sm"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
            <div
              className={isMobile ? "col-12 mt-2" : "col-1 "}
              onClick={() => {
                getCurrentBets();
                setPageNumber(1);
              }}
            >
              <button className="btn btn-primary btn-block">Submit</button>
            </div>
          </div>
          <div className="row  row5 mt-2">
            <div className={isMobile ? "col-12 " : "col-2"}>
              <label
                style={{
                  marginLeft: "10px",
                }}
                className="col-form-label"
              >
                Size
              </label>
              <div className={isMobile ? "col-12" : "col-5"}>
                <select
                  onChange={(e) => {
                    setPageSize(e.target.value);
                  }}
                  className="form-control form-control-sm"
                  value={pageSize}
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                  <option value={200}>200</option>
                  <option value={500}>500</option>
                  <option value={1000}>1000</option>

                </select>
              </div>
            </div>
          </div>
          <div className="row row5 mt-2">
            <div className="col-12">
              <div className="table-responsive">
                <table
                  role="table"
                  aria-busy="false"
                  aria-colcount={8}
                  className="table b-table table-bordered"
                  id="__BVID__104"
                >
                  <thead role="rowgroup" className="">
                    <tr role="row" className="">
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={1}
                        className="text-center"
                      >
                        Event Name
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={2}
                        className="text-center"
                      >
                        Nation
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={3}
                        className="text-center"
                      >
                        Event Type
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={3}
                        className="text-center"
                      >
                        Market Name
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={4}
                        className="text-center"
                      >
                        User Rate
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={5}
                        className="text-right"
                      >
                        Stake
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={6}
                        className="text-right"
                      >
                        Profit/Loss
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={7}
                        className="text-center"
                      >
                        Place Date
                      </th>
                      <th
                        role="columnheader"
                        scope="col"
                        aria-colindex={8}
                        className="text-center"
                      >
                        Settlement Date
                      </th>
                    </tr>
                  </thead>
                  <tbody role="rowgroup">
                    {data?.map((item, index) => (
                      <tr
                        role="row"
                        className={item?.back_run ? "back" : "lay"}
                        key={index}
                      >
                        <td role="cell" className="text-left">
                          {item.event_name}
                        </td>
                        <td role="cell" className="text-center">
                          {item.runner_name}
                        </td>
                        <td role="cell" className="text-center">
                          {item.event_type}
                        </td>
                        <td role="cell" className="text-center">
                          {item.marketName}
                        </td>
                        <td role="cell" className="text-center">
                          {item.rate}
                        </td>
                        <td role="cell" className="text-right">
                          {item.amount}
                        </td>
                        <td
                          role="cell"
                          className={`text-right`}
                          style={{ color: item.loss < 0 ? "red" : "green" }}
                        >
                          {item.loss ? item?.loss : item?.profit}
                        </td>
                        <td role="cell" className="text-center">
                          {moment(item?.created_date)?.format(
                            "DD:MM:YYYY HH:mm:ss"
                          )}
                        </td>
                        <td role="cell" className="text-center">
                          {moment(item?.match_date)?.format(
                            "DD:MM:YYYY HH:mm:ss"
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="row row5 mt-2">
            <div className="col-12" />
          </div>
          {/* <div className="row row5 mt-2">
  <div className="col-12">
    <ul
      role="menubar"
      aria-disabled="false"
      aria-label="Pagination"
      className="pagination mb-0 b-pagination justify-content-center"
    >
      
      <li className={`page-item ${pageNumber === 0 ? "disabled" : ""}`}>
        <span
          className="page-link"
          onClick={() => pageNumber > 0 && setPageNumber(0)}
        >
          First
        </span>
      </li>

    
      <li className={`page-item ${pageNumber === 0 ? "disabled" : ""}`}>
        <span
          className="page-link"
          onClick={() => pageNumber > 0 && setPageNumber(pageNumber - 1)}
        >
          Prev
        </span>
      </li>

     
      {Array.from(Array(noOfPages).keys()).map((item) => (
        <li
          key={item}
          className={`page-item ${pageNumber === item ? "active" : ""}`}
        >
          <span
            role="menuitemradio"
            aria-label={`Go to page ${item + 1}`}
            aria-checked={pageNumber === item}
            className="page-link"
            onClick={() => setPageNumber(item)}
          >
            {item + 1}
          </span>
        </li>
      ))}

      
      <li className={`page-item ${pageNumber === noOfPages - 1 ? "disabled" : ""}`}>
        <span
          className="page-link"
          onClick={() =>
            pageNumber < noOfPages - 1 && setPageNumber(pageNumber + 1)
          }
        >
          Next
        </span>
      </li>

      <li className={`page-item ${pageNumber === noOfPages - 1 ? "disabled" : ""}`}>
        <span
          className="page-link"
          onClick={() =>
            pageNumber < noOfPages - 1 && setPageNumber(noOfPages - 1)
          }
        >
          Last
        </span>
      </li>
    </ul>
  </div>
</div> */}
  <tfoot>
                    {/* Pagination */}
                    <tr>
                      <td colSpan={2}>
                        <div className="d-flex justify-content-between">
                          <div>
                            <button
                              // onClick={() => setPage(page - 1)}
                              onClick={() => setPageSize(pageSize - 1)}
                              className="btn btn-primary"
                              disabled={page == 0}
                            >
                              Previous
                            </button>
                          </div>&nbsp;
                          <div>
                            <button
                              // onClick={() => setPage(page + 1)}
                              onClick={() => setPageSize(pageSize + 1)}
                              className="btn btn-primary"
                              disabled={data.length < size}
                            >
                              Next
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
        </div>
      </div>
    </div>
  );
}
